function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 1.967)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M168.352,378.533h-17.7a1.149,1.149,0,0,1-1.148-1.148V361.648a1.149,1.149,0,0,1,1.148-1.148h17.7a1.149,1.149,0,0,1,1.148,1.148v15.738A1.149,1.149,0,0,1,168.352,378.533Zm-17.7-17.049a.166.166,0,0,0-.164.164v15.738a.166.166,0,0,0,.164.164h17.7a.166.166,0,0,0,.164-.164V361.648a.166.166,0,0,0-.164-.164Z",
  transform: "translate(-149.5 -360.5)"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(6.23)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M168.992,358.762a.492.492,0,0,1-.492-.492v-3.279a.492.492,0,1,1,.984,0v3.279A.492.492,0,0,1,168.992,358.762Z",
  transform: "translate(-168.5 -354.5)"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(12.787)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M188.992,358.762a.492.492,0,0,1-.492-.492v-3.279a.492.492,0,1,1,.984,0v3.279A.492.492,0,0,1,188.992,358.762Z",
  transform: "translate(-188.5 -354.5)"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(3.934 7.541)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 0)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M163.3,379.8h-1.311a.492.492,0,0,1-.492-.492v-1.311a.492.492,0,0,1,.492-.492H163.3a.492.492,0,0,1,.492.492V379.3A.492.492,0,0,1,163.3,379.8Zm-.82-.984h.328v-.328h-.328Z",
  transform: "translate(-161.5 -377.5)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(4.918 0)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M178.3,379.8h-1.311a.492.492,0,0,1-.492-.492v-1.311a.492.492,0,0,1,.492-.492H178.3a.492.492,0,0,1,.492.492V379.3A.492.492,0,0,1,178.3,379.8Zm-.82-.984h.328v-.328h-.328Z",
  transform: "translate(-176.5 -377.5)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(9.836 0)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M193.3,379.8h-1.311a.492.492,0,0,1-.492-.492v-1.311a.492.492,0,0,1,.492-.492H193.3a.492.492,0,0,1,.492.492V379.3A.492.492,0,0,1,193.3,379.8Zm-.82-.984h.328v-.328h-.328Z",
  transform: "translate(-191.5 -377.5)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 4.918)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M163.3,394.8h-1.311a.492.492,0,0,1-.492-.492v-1.311a.492.492,0,0,1,.492-.492H163.3a.492.492,0,0,1,.492.492V394.3A.492.492,0,0,1,163.3,394.8Zm-.82-.984h.328v-.328h-.328Z",
  transform: "translate(-161.5 -392.5)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(4.918 4.918)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M178.3,394.8h-1.311a.492.492,0,0,1-.492-.492v-1.311a.492.492,0,0,1,.492-.492H178.3a.492.492,0,0,1,.492.492V394.3A.492.492,0,0,1,178.3,394.8Zm-.82-.984h.328v-.328h-.328Z",
  transform: "translate(-176.5 -392.5)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(9.836 4.918)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M193.3,394.8h-1.311a.492.492,0,0,1-.492-.492v-1.311a.492.492,0,0,1,.492-.492H193.3a.492.492,0,0,1,.492.492V394.3A.492.492,0,0,1,193.3,394.8Zm-.82-.984h.328v-.328h-.328Z",
  transform: "translate(-191.5 -392.5)"
})));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgCalendar, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Calendar.e1c961bd.svg";
export { ForwardRef as ReactComponent };